<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="100px">
					<el-form-item label="触发器名称"><el-input v-model="queryParams.title" placeholder="请输入触发器名称"></el-input></el-form-item>
					<el-form-item label="模版名称"><el-input v-model="queryParams.templateTitle" placeholder="请输入模版名称"></el-input></el-form-item>
					<el-form-item label="变量名称"><el-input v-model="queryParams.variableTitle" placeholder="请输入变量名称"></el-input></el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
						<el-button type="primary" size="small" @click="handleAdd" v-has="'btn_add'">添加</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column prop="title" label="触发器名称"></el-table-column>
					<el-table-column prop="templateTitle" label="模版名称"></el-table-column>
					<el-table-column prop="creatorName" label="创建人名称"></el-table-column>
					<el-table-column prop="updateTime" label="更新时间"></el-table-column>
					<el-table-column fixed="right" label="操作" :width="width">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleDetail(scope.row)">查看</el-button>
							<el-button size="mini" type="primary" @click="handleEdit(scope.row)" v-has="'btn_edit'">编辑</el-button>
							<el-button size="mini" type="danger" @click="batchUpdateStatus(-1,'删除',scope.row.id)" v-has="'btn_del'">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>


		<templateTriggerAdd :dialogVisible.sync="dialogVisible" :addOrUpdateForm="addOrUpdateForm" :title="title"  @custom-event="getList"></templateTriggerAdd>
		
		<templateTriggerDetail :dialogDetailVisible.sync="dialogDetailVisible" :addOrUpdateForm="addOrUpdateForm" ></templateTriggerDetail>


		
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';
	import templateTriggerAdd from '@/components/layout/devices/templateTriggerAdd';
	import templateTriggerDetail from '@/components/layout/devices/templateTriggerDetail';

	export default {
		extends: BaseSearch,
		components: {
			templateTriggerAdd,
			templateTriggerDetail
		},
		data() {
			return {
				url: 'template/trigger',
				name: '模版触发器',
				dialogDetailVisible: false
			}
		},
		methods: {
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {
						"openAlarm":false
					};
				}
			},
			handleDetail(row) {
				if (this.$refs.addOrUpdateForm != undefined) {
					this.$refs['addOrUpdateForm'].resetFields();
				}
				this.createUpdateForm(row);
				this.dialogDetailVisible = true;
			},
			beforeUpdate() {},
		},
		mounted: function() {
			if (this.$route.query.templateTitle) {
				this.queryParams.templateTitle = this.$route.query.templateTitle;
			}
			if (this.$route.query.variableTitle) {
				this.queryParams.variableTitle = this.$route.query.variableTitle;
			}
			this.institutionId = sessionStorage.getItem('_institutionId');
			this.roleId = sessionStorage.getItem('_roleId');
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/device/templateTrigger.vue